import { Button } from '@zond/ui';
import { useTranslation } from 'react-i18next';
import { getLogo } from '../../../utils/get-logo';
import { ClientDownloadOptions, detectUserOS } from '../downloads/client-download-options';

export function UserDashboard() {
  const { t } = useTranslation('dashboard');
  const userOS = detectUserOS();

  return (
    <div className="h-[calc(100vh-64px)] flex flex-col">
      <div className="relative flex-1">
        <div className="absolute inset-0 bg-background/90 dark:bg-background/95 backdrop-blur-xs z-10 flex flex-col items-center justify-center">
          <div className="bg-gradient-to-b from-card to-card rounded-xl p-8 shadow-2xl max-w-2xl mx-auto text-center border border-border/50 animate-in fade-in slide-in-from-bottom-4 duration-500">
            <div className="flex justify-center items-center mb-6">
              <img
                src={getLogo()}
                alt={t('logoAlt')}
                className="w-16 h-16 dark:border dark:border-border/20 dark:rounded-full"
              />
            </div>
            <h2 className="text-3xl font-bold mb-3 bg-gradient-to-r from-primary/90 to-primary bg-clip-text text-transparent">
              {t('user.welcomeTitle')}
            </h2>
            <p className="text-muted-foreground text-lg mb-8 max-w-md mx-auto">{t('user.downloadPrompt')}</p>

            <ClientDownloadOptions className="max-w-3xl mx-auto" />
          </div>
        </div>
      </div>
    </div>
  );
}
